import {
  Conversation,
  ConversationListItem,
  ConversationWithParticipants,
  Message,
} from '@/types/chat/conversations.types';
import { Session } from 'next-auth';
import { apiService as api } from './api.service';

const CHAT_API_URL = '/chat';

class ChatService {
  async createConversation(
    receiverId: string,
    session: Session
  ): Promise<Conversation> {
    const response = await api.post(
      `${CHAT_API_URL}/conversations`,
      {
        receiverId,
      },
      session
    );
    return response as Conversation;
  }

  async getConversations(session: Session): Promise<ConversationListItem[]> {
    try {
      const response = await api.get(`${CHAT_API_URL}/conversations`, session);
      return response as ConversationListItem[];
    } catch (error) {
      console.error('ChatService: Error fetching conversations:', error);
      throw error;
    }
  }

  async getConversation(
    id: string,
    session: Session
  ): Promise<Conversation | null> {
    try {
      const response = await api.get(
        `${CHAT_API_URL}/conversations/${id}`,
        session
      );
      return response as Conversation;
    } catch (error) {
      console.error('ChatService: Error fetching conversation:', error);
      throw error;
    }
  }

  async createMessage(
    conversationId: string,
    content: string,
    session: Session
  ): Promise<Message> {
    const response = await api.post(
      `${CHAT_API_URL}/messages`,
      {
        conversationId,
        content,
      },
      session
    );

    return response as Message;
  }

  async getUnreadNotifications(session: Session): Promise<any> {
    try {
      const response = await api.get(
        `${CHAT_API_URL}/unread-notifications`,
        session
      );
      return response;
    } catch (error) {
      console.error('ChatService: Error fetching unread notifications:', error);
      throw error;
    }
  }

  async getConversationWithParticipants(
    id: string,
    session: Session
  ): Promise<ConversationWithParticipants> {
    const response = await api.get(
      `${CHAT_API_URL}/conversations/${id}/with-participants`,
      session
    );
    return response as ConversationWithParticipants;
  }
}

export const chatService = new ChatService();
